// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Error from '../core/error';
import Loading from '../core/loading';
import Permissions from '../core/permissions';
import DisplayPathModifierForm from './display-path-modifier-form';

// Containers
import withDelete from '../../containers/with-delete';
import withForm from '../../containers/with-form';

// Styles
import './edit-display-path-modifier.scss';

const formName = 'editDisplayPathModifier';

function EditDisplayPathModifier({formData, resetForm, searchFetching, searchValues: {networkDisplayPathModifierId}}) {
    const getFormProps = () => ({
        className: 'edit-display-path-modifier',
        editing: true,
        formData,
        formName,
        onReset: (submitted, resetValues) => resetForm(submitted, resetValues, true),
    });

    return (
        <Permissions
            allowRoles={['networkDisplayPathModifier_update', 'networkDisplayPathModifier_delete']}
            notAuthorizedMessage={true}
        >
            {networkDisplayPathModifierId ? (
                <Permissions allowRoles={['networkDisplayPathModifier_update']} notAuthorizedMessage={false}>
                    <DisplayPathModifierForm {...getFormProps()} />
                </Permissions>
            ) : (
                <Error
                    className="edit-display-path-modifier--message"
                    error="Select a display path modifier from the list."
                />
            )}
            <Loading loading={searchFetching} />
        </Permissions>
    );
}

EditDisplayPathModifier.propTypes = {
    formData: PropTypes.object.isRequired,
    resetForm: PropTypes.func.isRequired,
    searchFetching: PropTypes.bool,
    searchValues: PropTypes.object,
};

export default withDelete(withForm(EditDisplayPathModifier, formName), ['networkdisplaypathmodifier_delete'], formName);
